import type { FC, PropsWithChildren } from 'react'

import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import Link from '@mui/material/Link'
import Typography from '@mui/material/Typography'

const mijnaansluitingLogo = '/images/mijnaansluiting-logo-liggend.png'

const StyledLink: FC<PropsWithChildren<{ url: string }>> = ({
  url,
  children,
}) => {
  return (
    <Typography sx={{ pt: '5px', pb: 1, ml: 5 }}>
      <Link
        href={url}
        target="_blank"
        rel="noreferrer"
        sx={{
          color: '#2d3f58',
          fontWeight: 500,
          marginTop: '1em',
          marginBottom: '1em',
          textDecoration: 'none',
          '&:hover': {
            textDecoration: 'underline',
          },
        }}
      >
        {children}
      </Link>
    </Typography>
  )
}

const LinkHeader: FC<PropsWithChildren> = ({ children }) => {
  return (
    <Typography
      sx={{
        fontFamily: '"Aller Bold",Helvetica,Arial,sans-serif',
        fontSize: '1.3em',
        color: '#2d3f58',
        fontWeight: 600,
        pb: 2,
      }}
    >
      {children}
    </Typography>
  )
}

export const LinkGrid: FC = () => {
  return (
    <Grid container sx={{ width: '80%', m: 'auto' }} spacing={10}>
      <Grid size={{ xs: 12, md: 4 }}>
        <LinkHeader>Informatie</LinkHeader>
        <StyledLink url="https://mijnaansluiting.atlassian.net/wiki/spaces/Wiki/pages/39911528/CAPO+UI+Handleiding">
          Handleiding
        </StyledLink>
        <StyledLink url="https://mijnaansluiting.atlassian.net/wiki/spaces/Wiki/pages/40271873/Release+notes+CAPO">
          Release notes
        </StyledLink>
      </Grid>

      <Grid size={{ xs: 12, md: 4 }}>
        <LinkHeader>Mijnaansluiting.nl</LinkHeader>
        <StyledLink url="https://mijnaansluiting.nl/over-mijnaansluiting">
          Over Mijnaansluiting.nl
        </StyledLink>
        <StyledLink url="https://mijnaansluiting.atlassian.net/wiki/spaces/Wiki/pages/61505589/CAPO+Privacy+Policy">
          Privacybeleid CAPO
        </StyledLink>
        <StyledLink url="https://mijnaansluiting.atlassian.net/wiki/spaces/Wiki/pages/60850268/CAPO+Disclaimer">
          Disclaimer CAPO
        </StyledLink>
      </Grid>

      <Grid size={{ xs: 6, md: 4 }}>
        <Link
          href="https://stichting.mijnaansluiting.nl"
          target="_blank"
          rel="noreferrer"
        >
          <Box
            component="img"
            sx={{ maxWidth: '100%' }}
            src={mijnaansluitingLogo}
            alt="mijn aansluiting Logo"
          />
        </Link>
      </Grid>
    </Grid>
  )
}
